import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import { addUser, getUserList } from "../../services/Users-services";
import { toast } from "sonner";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import profileImage from "../../assets/images/no-profile-picture.png";
import {
  createTutor,
  getTutorDetails,
  updateTutor,
} from "../../services/Academic-Services.js";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,
} from "../../../src/services/utilityFunctions.js";
import { useGlobalState } from "../../../src/services/hostelConst";
import Select from "react-select";
import { getLocalStorageData } from "../../services/axiosComponent";
import { selectStyle } from "../../services/constant";
import {
  openModal,
  closeModal,
} from "../../services/redux/reducers/modalSlice";
import { useSelector, useDispatch } from "react-redux";
const AddTutorForm = ({ navigate, refresh }) => {
  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const [regionOptions, setRegionOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSiteOptionsLoading, setIsSiteOptionsLoading] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const [tutorOptions, setTutorOptions] = useState([]);
  const [isTutorLoading, setIsTutorLoading] = useState(false);
  const [isSiteSearchable, setIsSiteSearchable] = useState(true);
  const [isRegionSearchable, setIsRegionSearchable] = useState(true);
  const prepareFormData = (data = null) => {
    return {
      siteId: {
        value: data != null ? data["_SITE"] : "",
        label: data != null ? data["SITE"] : "",
      },
      regionId: {
        value: data != null ? data["_REGION"] : "",
        label: data != null ? data["REGION"] : "",
      },
      tutorId: {
        value: data != null ? data["_ID"] : "",
        label: data != null ? data["NAME"] : "",
      },
    };
  };
  const [loadingData, setLoadingData] = useState(modal.isEditing);
  const [formData, setFormData] = useState(prepareFormData());
  const getTutorDetailData = async (entityId) => {
    setLoadingData(true);
    var res = await getTutorDetails(entityId);
    if (res.status == "success") {
      console.log(res, "get tutor details");
      setFormData(prepareFormData(res.data));
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingData(false);
  };

  const handleChange = (field, value) => {
    setErrors({});
    if (field == "regionId") {
      setFormData((prev) => ({ ...prev, siteId: { value: "", label: "" } }));
      setFormData((prev) => ({
        ...prev,
        tutorId: { value: "", label: "" },
      }));
    }
    if (field == "siteId") {
      setFormData((prev) => ({
        ...prev,
        tutorId: { value: "", label: "" },
      }));
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateFields = () => {
    let isValid = true;
    let errors = {};

    if (formData.tutorId.value == "") {
      isValid = false;
      errors.tutorId = "Tutor is required";
    }
    if (formData.regionId.value == "") {
      isValid = false;
      errors.region = "Region is required";
    }
    if (formData.siteId.value == "") {
      isValid = false;
      errors.site = "Site is required";
    }
    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (validateFields()) {
      setLoading(true);

      var submitData = {
        userId: formData.tutorId.value,

        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
        regionId: formData.regionId.value,
        siteId: formData.siteId.value,
        id: modal.isEditing ? modal.data._ID : null,
      };
      var res = modal.isEditing
        ? await updateTutor(submitData)
        : await createTutor(submitData);
      if (res.status == "success") {
        callToast(
          "success",
          modal.isEditing ? "Updated" : "Created",
          modal.isEditing ? "Tutor details updated" : "Tutor added successfully"
        );

        await refresh({ columnRefresh: false, isLoading: false });
        setLoading(false);
        dispatch(closeModal());
      } else {
        console.log(res, "add Tutor resss");
        setLoading(false);
        showErrorMessages({
          data: res,
          navigate,
        });
      }
    }
  };

  const getSiteList = async (regionId, query) => {
    setIsSiteOptionsLoading(true);
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = await prepareSiteList(regionId, navigate, query);

    if (
      list.length == 1 &&
      list[0].value == data._SITE &&
      data["_SITE ACCESS_"] == null
    ) {
      setIsSiteSearchable(false);
      handleChange("siteInfo", "site", {
        value: list[0].value,
        label: list[0].label,
      });
    }

    setIsSiteOptionsLoading(false);
    if (list.length == 0) {
      setErrors((prev) => ({
        ...prev,
        site: "No site available for this region",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        site: "",
      }));
    }
    setSiteOptions(list);
  };

  const getRegionList = async () => {
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = JSON.parse(localStorage.getItem("regionList"));
    if (
      list.length == 1 &&
      list[0].value == data._REGION &&
      data["_REGION_ACCESS_"] == null
    ) {
      setIsRegionSearchable(false);
      handleChange("siteInfo", "region", {
        value: list[0].value,
        label: list[0].label,
      });
    }
    setRegionOptions(list);
  };

  const getUserListForTutors = async (siteId) => {
    setIsTutorLoading(true);
    var res = await getUserList({
      regionId: formData.regionId.value,
      siteId: siteId,
      status: "Y",
    });
    if (res.status == "success") {
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });
      setIsTutorLoading(false);
      setTutorOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
  };

  useEffect(() => {
    getRegionList();
    if (modal.isEditing == true) {
      getTutorDetailData(modal.data._ID);
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div className="">
            <div className="d-flex">
              <div className="w-100 ps-5 pe-5">
                <form>
                  <>
                    <div className="mb-3 ">
                      <label className="form-label">Region </label>

                      <Select
                        styles={selectStyle}
                        options={regionOptions}
                        value={
                          formData.regionId.label == ""
                            ? null
                            : formData.regionId
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "regionId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );

                          if (newValue != null) {
                            getSiteList(newValue.value);
                          }
                        }}
                        onInputChange={(inputValue, { action }) => {}}
                        noOptionsMessage={() => {
                          return !isRegionSearchable
                            ? "Region Access not available"
                            : "No matches found";
                        }}
                        isSearchable={isRegionSearchable}
                        placeholder="Select Region "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.region && (
                        <small className="text-danger">{errors.region}</small>
                      )}
                    </div>
                    <div className="mb-3 ">
                      <label className="form-label">Site</label>

                      <Select
                        styles={selectStyle}
                        options={siteOptions}
                        value={
                          formData.siteId.label == "" ? null : formData.siteId
                        }
                        components={
                          isSiteOptionsLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "siteId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );

                          getUserListForTutors(newValue.value);
                        }}
                        onInputChange={(inputValue, { action }) => {
                          getSiteList(formData.regionId.value, inputValue);
                        }}
                        noOptionsMessage={() => {
                          return !isSiteSearchable
                            ? "Site Access Not available"
                            : "No matches found";
                        }}
                        isSearchable={isSiteSearchable}
                        placeholder="Select Site "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.site && (
                        <small className="text-danger">{errors.site}</small>
                      )}
                    </div>
                    <div className="mb-3 ">
                      <label className="form-label">Tutor</label>

                      <Select
                        styles={selectStyle}
                        options={tutorOptions}
                        value={
                          formData.tutorId.label == "" ? null : formData.tutorId
                        }
                        components={
                          isTutorLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "tutorId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                          }
                        }}
                        noOptionsMessage={() => {
                          return "No Tutor   available";
                        }}
                        isSearchable={true}
                        placeholder="Select  Tutor"
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.tutorId && (
                        <small className="text-danger">{errors.tutorId}</small>
                      )}
                    </div>
                  </>

                  <div className="d-flex justify-content-end mt-4 gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddTutorForm;
